import React, { useState } from 'react';

function UnderConstruction() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) setSubmitted(true);
  };

  return (
    <div style={styles.container}>
      {/* Background Graphic Element */}
      <div style={styles.badge}>
        <span style={styles.crossIcon}>✚</span> Independent Pharmacy Network
      </div>

      <h1 style={styles.title}>
        <span style={styles.highlight}>ResQ-Script Integration</span><br />
        is Under Construction
      </h1>

      <p style={styles.subtitle}>
        We’re crafting a dedicated platform and seamless integration engine designed 
        empower independent pharmacies to thrive. Something healthy is brewing!
      </p>

      {/* Feature Highlights */}
      <div style={styles.grid}>
        <div style={styles.card}>
          <span style={styles.cardIcon}>💊</span>
          <h3 style={styles.cardTitle}>Smart Integration</h3>
          <p style={styles.cardText}>ResQ-Scripts will be generated from the direct vexall system pharmacies already use.</p>
        </div>
        <div style={styles.card}>
          <span style={styles.cardIcon}>🏥</span>
          <h3 style={styles.cardTitle}>Independent First</h3>
          <p style={styles.cardText}>Tailored tools designed specifically for local and independent operations.</p>
        </div>
      </div>

      {/* Email Capture / Action */}
      {/*
      !submitted ? (
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="email"
            placeholder="Enter your pharmacy email for early access..."
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={styles.input}
          />
         
          <button type="submit" className="btn-rescure" style={{ cursor: 'pointer' }}>
            Get Notified
          </button>
        </form>
      ) : (
        <div style={styles.successMessage}>
          ✓ Thank you! We'll notify you as soon as we launch.
        </div>
      )
      */}

      <footer style={styles.footer}>
        &copy; {new Date().getFullYear()} Pharmacy Integration Platform. All rights reserved.
      </footer>
    </div>
  );
}

// Inline styles designed to blend with your global CSS
const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
    boxSizing: 'border-box',
    textAlign: 'center',
    backgroundColor: '#f8fafc',
    color: '#2d3748',
  },
  badge: {
    backgroundColor: '#e6f4ea',
    color: '#2e7d32',
    padding: '6px 16px',
    borderRadius: '20px',
    fontSize: '14px',
    fontWeight: '700',
    marginBottom: '20px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
  },
  crossIcon: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: '800',
    color: '#1a202c',
    margin: '0 0 16px 0',
    lineHeight: '1.2',
  },
  highlight: {
    color: '#C73D39', // Uses your brand red color
  },
  subtitle: {
    fontSize: '1.1rem',
    color: '#4a5568',
    maxWidth: '600px',
    margin: '0 0 40px 0',
    lineHeight: '1.6',
  },
  grid: {
    display: 'flex',
    gap: '20px',
    maxWidth: '600px',
    width: '100%',
    marginBottom: '40px',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  card: {
    flex: '1 1 250px',
    backgroundColor: '#ffffff',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
    border: '1px solid #e2e8f0',
    textAlign: 'left',
  },
  cardIcon: {
    fontSize: '24px',
    display: 'block',
    marginBottom: '8px',
  },
  cardTitle: {
    margin: '0 0 6px 0',
    fontSize: '1rem',
    color: '#2d3748',
  },
  cardText: {
    margin: 0,
    fontSize: '0.875rem',
    color: '#718096',
    lineHeight: '1.4',
  },
  form: {
    display: 'flex',
    gap: '10px',
    maxWidth: '480px',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  input: {
    flex: '1 1 240px',
    padding: '12px 18px',
    borderRadius: '23px',
    border: '1px solid #cbd5e0',
    fontSize: '14px',
    outline: 'none',
  },
  successMessage: {
    backgroundColor: '#def7ec',
    color: '#03543f',
    padding: '12px 24px',
    borderRadius: '23px',
    fontWeight: '600',
    fontSize: '14px',
  },
  footer: {
    marginTop: '60px',
    fontSize: '0.8rem',
    color: '#a0aec0',
  },
};

export default UnderConstruction;